module.exports = __webpack_public_path__ + "media/หวัดดีครับผมคือจุ้บเหม่ง.ba1ba33a.mp3";